module.exports = __webpack_public_path__ + "static/media/9a.02953908.jpg";